/**
*@Author zhoutong
*@Date 2022-11-08
*@Project WebStorm-admin-feature-cooperation-manage
*/
<template>
  <div class="WaitTable-container">
    <el-table
        v-loading="loading"
        :data="data"
        :header-cell-style="{background:'#F9F9F9'}"
        height="60vh"
        style="width: 100%">
      <el-table-column
          type="index"
          label="序号"
          width="50">
      </el-table-column>
      <el-table-column
          prop="title"
          show-overflow-tooltip
          label="标题">
        <template slot-scope="scope">
          <span style="cursor: pointer;color: #0d9869"
                @click="open(scope.row.bLink)"
                v-if="scope.row.bLink">【{{scope.row.secondCategory}}】{{scope.row.title}}</span>
          <span v-else >【{{scope.row.secondCategory}}】{{scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createUserName"
          label="发起人"
          width="180">
      </el-table-column>
      <el-table-column
          prop="doneTime"
          width="180"
          sortable
          label="处理时间">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {

  name: "WaitTable",

  props: {
    data:{
      type: Array,
      default: () => [],
    },
    loading:{
      type: Boolean,
      default: () => false,
    }
  },

  components: {},

  data() {
    return {}
  },

  watch: {},

  mounted() {
  },

  methods: {
    open(url){
      window.open(url)
    }
  },

}
</script>

<style scoped lang="scss">
.WaitTable-container {
}
</style>